import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  text: {
    color: theme.palette.text.primary,
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 12,
  },
}));
